import { render, staticRenderFns } from "./TencentSection.vue?vue&type=template&id=1987e21e&scoped=true"
import script from "./TencentSection.vue?vue&type=script&lang=js"
export * from "./TencentSection.vue?vue&type=script&lang=js"
import style0 from "./TencentSection.vue?vue&type=style&index=0&id=1987e21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987e21e",
  null
  
)

export default component.exports